import React, { CSSProperties } from 'react';
import styles from './success.module.scss';
import { SuccessImg} from '../../Assets/Images'
import Button from '../Button/button';
import { ButtonTypes } from '../../Interfaces/componentTypes';

interface IProps {
  message?: string;
  styleProps?: CSSProperties;
  buttonTitle:string;
  onClick:()=>void;
}

const Success: React.FC<IProps> = (props) => {
    const { message = "Success!", styleProps,buttonTitle,onClick } = props;
  return (
    <div className={styles.container}>
    <div className={styles.successContainer} style={styleProps}>
      <div className={styles.checkmarkContainer}>
        <img src={SuccessImg} alt='success.png'/>
      </div>
      <p className={styles.message}>{message}</p>
    </div>
    <Button
    buttonType={ButtonTypes.Primery}
    title={buttonTitle}
    onClick={onClick}
    buttonStyle={styles.animatedButton}
    />
    </div>
  );
};

export default Success;
